import {
  reportEvent as publicReportEvent,
  bulkReportEvent as publicBulkReportEvent,
  bulkCancelEvent as publicBulkCancelEvent,
  cancelEvent as publicCancelEvent,
  rerunActivation as publicRerunActivation,
  reportActionInvocationCompleted as publicReportActionInvocationCompleted,
} from './automations-v2-activation-activations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const reportEvent: MaybeContext<
  BuildRESTFunction<typeof publicReportEvent> & typeof publicReportEvent
> = /*#__PURE__*/ createRESTModule(publicReportEvent);
export const bulkReportEvent: MaybeContext<
  BuildRESTFunction<typeof publicBulkReportEvent> & typeof publicBulkReportEvent
> = /*#__PURE__*/ createRESTModule(publicBulkReportEvent);
export const bulkCancelEvent: MaybeContext<
  BuildRESTFunction<typeof publicBulkCancelEvent> & typeof publicBulkCancelEvent
> = /*#__PURE__*/ createRESTModule(publicBulkCancelEvent);
export const cancelEvent: MaybeContext<
  BuildRESTFunction<typeof publicCancelEvent> & typeof publicCancelEvent
> = /*#__PURE__*/ createRESTModule(publicCancelEvent);
/** @internal */
export const rerunActivation: MaybeContext<
  BuildRESTFunction<typeof publicRerunActivation> & typeof publicRerunActivation
> = /*#__PURE__*/ createRESTModule(publicRerunActivation);
export const reportActionInvocationCompleted: MaybeContext<
  BuildRESTFunction<typeof publicReportActionInvocationCompleted> &
    typeof publicReportActionInvocationCompleted
> = /*#__PURE__*/ createRESTModule(publicReportActionInvocationCompleted);

export {
  Domain,
  TimeUnit,
  Operator,
  CodeSnippetLanguage,
  Type,
  AutomationConfigurationStatus,
  Origin,
  ActivationInitiationSource,
  Target,
  CancellationReason,
  ErrorReason,
  SkipReason,
  ActivationStatusChangedStatus,
  Units,
  ScheduleStatus,
  WebhookIdentityType,
  BlockType,
  Language,
  IdentifierType,
  RuntimeStatus,
  Status,
  ActivationActionStatusChangedStatus,
} from './automations-v2-activation-activations.universal.js';
export {
  Activation,
  Automation,
  AutomationOriginInfoOneOf,
  AIMetadata,
  ActionSettings,
  TriggerSettings,
  Enrichment,
  AuditInfo,
  AuditInfoIdOneOf,
  AutomationConfiguration,
  Filter,
  FutureDateActivationOffset,
  RateLimit,
  FilterValueSelection,
  ConditionExpressionGroup,
  ActionCodeSnippet,
  SplitActionPath,
  AppDefinedAction,
  ConditionAction,
  CodeConditionAction,
  DelayAction,
  RateLimitAction,
  SetVariablesAction,
  OutputAction,
  ActionSplitAction,
  MergeAction,
  Trigger,
  AutomationConfigurationAction,
  AutomationConfigurationActionInfoOneOf,
  FilterableAppDefinedActions,
  ApplicationOrigin,
  PreinstalledOrigin,
  AutomationSettings,
  DraftInfo,
  Enrichments,
  ExtendedFields,
  AutoArchivePolicy,
  Notes,
  Note,
  Position,
  Offset,
  Dimensions,
  ActivationInitiationSourceInfo,
  ActivationInitiationSourceInfoInitiationSourceInfoOneOf,
  ManualActivationInfo,
  RerunActivationInfo,
  InitiatorInfo,
  ActivationStatusChanged,
  ActivationStatusChangedStatusInfoOneOf,
  Identity,
  Metadata,
  InitiatedStatusInfo,
  ActivationStatusChangedStartedStatusInfo,
  ScheduledStatusInfo,
  CancelledStatusInfo,
  ActivationStatusChangedFailedStatusInfo,
  SkippedStatusInfo,
  ScheduleRequest,
  Schedule,
  ScheduledAction,
  Delay,
  DelayOfOneOf,
  SimpleDelay,
  TriggerInfo,
  ScheduleResponse,
  CancelPendingScheduleRequest,
  CancelPendingScheduleRequestByOneOf,
  CancelPendingScheduleResponse,
  UpdatePendingSchedulesPayloadRequest,
  UpdatePendingSchedulesPayloadResponse,
  GetScheduleRequest,
  GetScheduleResponse,
  UpdateScheduleStatusRequest,
  UpdateScheduleStatusResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ConsumeReportEventRequest,
  EventInfo,
  Idempotency,
  BatchActivationRequest,
  ActivationRequest,
  Runtime,
  Scheduler,
  AsyncAction,
  ActionData,
  Action,
  ActionActionOneOf,
  ServiceMapping,
  IfFilter,
  SwitchFilter,
  Case,
  DelayHelper,
  RateLimiting,
  ConditionFilter,
  ConditionBlock,
  CodeConditionFilter,
  CodeSnippet,
  Output,
  SetVariables,
  SplitAction,
  Path,
  Service,
  SystemHelper,
  SystemHelperHelperOneOf,
  SpiAction,
  ActivationSource,
  ActivationSourceOfOneOf,
  ActionsData,
  ScheduleActivationRequested,
  ActivationContinuedAfterSchedule,
  ReportEventRequest,
  ReportEventResponse,
  BulkReportEventRequest,
  BulkReportEventResponse,
  BulkReportEventResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkCancelEventRequest,
  BulkCancelEventResponse,
  BulkCancelEventResult,
  CancelEventRequest,
  CancelEventResponse,
  V1RunAutomationRequest,
  V1RunAutomationRequestIdentifierOneOf,
  PreinstalledIdentifier,
  AutomationIdentifier,
  V1RunAutomationResponse,
  TestAutomationRequest,
  TestAutomationRequestIdentifierOneOf,
  TestAutomationResponse,
  RerunActivationRequest,
  RunOptions,
  RerunActivationResponse,
  ReportDomainEventRequest,
  ReportDomainEventResponse,
  ReportAccountLevelEventRequest,
  ReportAccountLevelEventResponse,
  ExecuteFromActionRequest,
  ExecuteFromActionResponse,
  ActivationScheduleCompleted,
  Empty,
  ActionRetryRequest,
  ActivationContext,
  ResumeAfterAsyncActionCompleted,
  ResumeAfterAsyncActionCompletedStatusInfoOneOf,
  SuccessInfo,
  FailureInfo,
  ActivationActionStatusChanged,
  ActivationActionStatusChangedInfoOneOf,
  ActivationActionStatusChangedStatusInfoOneOf,
  RetryInfo,
  StartedStatusInfoAppDefinedActionInfo,
  StartedStatusInfoDelayActionInfo,
  InvokedAsyncStatusInfoAppDefinedActionInfo,
  ExpressionEvaluationResult,
  EndedStatusInfoAppDefinedActionInfo,
  ConditionActionInfo,
  CodeConditionActionInfo,
  RateLimitActionInfo,
  DelayActionInfo,
  SetVariablesActionInfo,
  AutomationInfo,
  AutomationInfoOriginInfoOneOf,
  AutomationInfoTriggerInfo,
  ActionAttributes,
  AppDefinedActionInfo,
  StartedStatusInfo,
  StartedStatusInfoTypeInfoOneOf,
  InvokedAsyncStatusInfo,
  InvokedAsyncStatusInfoTypeInfoOneOf,
  EndedStatusInfo,
  EndedStatusInfoTypeInfoOneOf,
  FailedStatusInfo,
  ActivationResumeAfterDelay,
  ActionCompletedRequest,
  RefreshPayloadRequest,
  RefreshPayloadResponse,
  RunAutomationRequest,
  RunAutomationResponse,
  RunPreinstalledAutomationRequest,
  RunPreinstalledAutomationResponse,
  ReportActionInvocationCompletedRequest,
  ReportActionInvocationCompletedRequestStatusInfoOneOf,
  ReportActionInvocationCompletedResponse,
  ReportEventOptions,
  RerunActivationOptions,
  ReportActionInvocationCompletedOptions,
  ReportActionInvocationCompletedOptionsStatusInfoOneOf,
} from './automations-v2-activation-activations.universal.js';
export {
  DomainWithLiterals,
  TimeUnitWithLiterals,
  OperatorWithLiterals,
  CodeSnippetLanguageWithLiterals,
  TypeWithLiterals,
  AutomationConfigurationStatusWithLiterals,
  OriginWithLiterals,
  ActivationInitiationSourceWithLiterals,
  TargetWithLiterals,
  CancellationReasonWithLiterals,
  ErrorReasonWithLiterals,
  SkipReasonWithLiterals,
  ActivationStatusChangedStatusWithLiterals,
  UnitsWithLiterals,
  ScheduleStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BlockTypeWithLiterals,
  LanguageWithLiterals,
  IdentifierTypeWithLiterals,
  RuntimeStatusWithLiterals,
  StatusWithLiterals,
  ActivationActionStatusChangedStatusWithLiterals,
  ReportEventApplicationErrors,
} from './automations-v2-activation-activations.universal.js';
